import { Alert } from 'antd';

export const PackagesAlert = () => {
  const onAlertClose = () => {
    sessionStorage.setItem('extranetPackagesAlertClosed', 'true');
  };

  if (sessionStorage.getItem('extranetPackagesAlertClosed')) {
    return null;
  }

  return (
    <Alert
      message="Notice an error in your configuration? Use the Assistance button in the bottom-right corner to report it."
      type="info"
      showIcon
      closable
      onClose={onAlertClose}
    />
  );
};
